const size = {
  xs: '320px',
  s: '480px',
  sm: '768px',
  m: '1024px',
  lg: '1200px',
}
const device = {
  xs: `(max-width: ${size.xs})`,
  s: `(max-width: ${size.s})`,
  sm: `(max-width: ${size.sm})`,
  m: `(max-width: ${size.m})`,
  lg: `(max-width: ${size.lg})`,
}
export default { size, device }
